import { FilteredDealsProvider } from '@/components/all-from-router/_components/deal-filters/filtered-deals/filtered-deals-provider';
import TradeCreateButton from '@/components/deal/trade/trade-create-button';
import VirtualizedTradeInAppraisalBoard from '@/components/trade/board/virtualized-trade-in-appraisal-board';
import FindInViewFilter from '@/components/ui/find-in-view-filter/find-in-view-filter';
import HeaderWithSidebarToggle from '@/components/ui/layout/header-with-sidebar-toggle';
import { PDKFilterIcon } from '@/components/ui/pdk-icons';
import HotkeyDialogBoxes from '@/components/ux/all-list-and-board/hotkey-dialog-boxes';
import useAllListAndBoardHotkeys from '@/components/ux/all-list-and-board/use-all-list-and-board-hotkeys';
import { toast } from '@/hooks/use-toast';
import useTrades from '@/hooks/use-trades';
import { createFileRoute } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';

export const Route = createFileRoute('/(authenticated)/trades/')({
  component: Index,
});

export const BoardPage = observer(() => {
  const { tradesByStatus } = useTrades();

  const { openDialog, setOpenDialog, selectedDeal, enableScope } =
    useAllListAndBoardHotkeys();

  return (
    <div className="flex flex-col">
      <div className="sticky top-0 bg-white z-20">
        <div className="flex flex-row justify-between text-md  px-2 py-2 items-center border-b text-gray-500">
          <HeaderWithSidebarToggle>
            <div className="flex flex-row items-center gap-2">
              <div>Trades</div>
              <TradeCreateButton
                dealId={selectedDeal?.id}
                dialogIsOpenProp={false}
              />
            </div>
          </HeaderWithSidebarToggle>
          <FindInViewFilter />
        </div>
        {/* <DealFilters /> */}
        <div
          className="flex flex-row items-center gap-2 cursor-pointer p-2"
          onClick={() => {
            toast({
              title: 'Filters not yet implemented',
              description:
                'Request for the trades filters on slack if you want it',
            });
          }}
        >
          <PDKFilterIcon className="size-4" />
          <span className="text-md  text-gray-500">Filter</span>
        </div>
      </div>

      <VirtualizedTradeInAppraisalBoard
        // dealsData={dealsData}
        // filterCallback={filterCallback}
        tradesByStatus={tradesByStatus}
        enableScope={enableScope}
        // shouldApplyFilteredDealsIds={shouldApplyFilteredDealsIds}
        // findInViewFilterCallback={findInViewFilterCallback}
      />

      <HotkeyDialogBoxes
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        selectedDeal={selectedDeal}
      />
    </div>
  );
});

function Index() {
  return (
    <FilteredDealsProvider>
      <BoardPage />
    </FilteredDealsProvider>
  );
}
